import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import {
  QuestionIdInfo,
  TikZType,
  autoReplaceStruct,
  course,
  coursesRes,
  deleteQuestionOrSectionConfirmation,
  displayGeneratedModule,
  genMatOption,
  generateQuestionStruct,
  generateQuestionStructNew,
  generatedQuestionObj,
  moduleSubTopic,
  moduleValidity,
  moduleWiseQuestionsTypeCount,
  options,
  quesDistributionPattern,
  questionInfo,
  saveTestModule,
  saveTestStruct,
  scoringSection,
  scoringSectionResBeforeParse,
  subTopicByScoringAndTestId,
  subTopicListByScoringId,
  subTopicQuestionDetail,
  subTopicQuestionDetailNew,
  subTopiclistByModule,
  testCreationSection,
  testType,
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { QuestionDistributionPatternComponent } from './dialogs/question-distribution-pattern/question-distribution-pattern.component';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { ManualReplaceDialogComponent } from './dialogs/manual-replace-dialog/manual-replace-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
// import { MathjaxDirective } from 'mathjax-angular';

declare var update: any;
declare var MathJax: any;

@Component({
  selector: 'app-test-creation',
  templateUrl: './test-creation.component.html',
  styleUrls: ['./test-creation.component.scss'],
})
export class TestCreationComponent implements OnInit, OnDestroy {
  // ** Edit test

  paramSubscription: Subscription = new Subscription();

  recievedTest: saveTestStruct = {
    testModuleDetails: [],
    testCode: '',
    testName: '',
    testNotes: '',
    testTypeId: 0,
  };

  recievedTestId: number = -1;

  isInGet: boolean = false;

  // ** Create test

  notifier: NotifierService;
  courses: string[] = ['Course 1', 'Course 2', 'Course 3'];

  scoringSectionsList: scoringSection[] = [];

  coursesList: course[] = [];

  testTypesList: testType[] = [];

  createdSections: testCreationSection[] = [];

  selectedTestType: FormControl = new FormControl('', [Validators.required]);

  subTopicsByScoringAndTestIdList: subTopiclistByModule[] = [];

  generateQuestionsFinalData: generateQuestionStruct[] = [];

  generateQuestionsOnlyForThisModule: generateQuestionStruct[] = [];

  // generatedModules: generateQuestionStruct[] = [];

  generatedModules: generateQuestionStructNew[] = [];

  generatedDisplayModules: displayGeneratedModule[] = [];

  images: any = null;

  totaltikZ: TikZType[] = [];

  difficultyLevels = [
    {
      level: 1,
      name: 'easy',
    },
    {
      level: 2,
      name: 'medium',
    },
    {
      level: 3,
      name: 'hard',
    },
  ];

  options = options;

  generatedModuleWiseQuestionTypeData: moduleWiseQuestionsTypeCount[] = [];

  presentQuestionIds: number[] = [];

  saveTestObj: saveTestStruct = {
    testModuleDetails: [],
    testCode: '',
    testName: '',
    testNotes: '',
    testTypeId: 0,
  };

  testNameOrId: string = '';

  testName: string = '';

  testId: FormControl = new FormControl('', Validators.required);

  isSaveValid: boolean = true;

  isValidQuesstionaire: boolean = false;

  moduleValidityList: moduleValidity[] = [];

  currentSection: number = 0;

  generatingQuestions: boolean = false;

  typeCountProcess: string[] = ['Update', 'Generate', 'Remove'];

  isSaveClicked: boolean = false;

  scoringSectionWithSubTopics: {
    [key: string | number]: subTopicByScoringAndTestId[];
  } | null = null;

  isDataLoading: boolean = false;

  isLeftSectionHidden: boolean = false;

  duplicateQuestions: QuestionIdInfo[] = [];

  showDuplicatesPopup: boolean = false;

  isDuplicateSaveAllowed: boolean = false;

  constructor(
    private globalApiService: GlobalApiService,
    private matDialog: MatDialog,
    notifierService: NotifierService,
    private activatedRoute: ActivatedRoute // private mathJax: MathjaxDirective
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.getTestIdParam();
    this.getCourses();
    this.getTestTypes();
    // ** for testing purposes (To directly test the save API call)
    // this.testSaveApiCall();
  }

  getTestIdParam() {
    // console.log('Params are ---> : ', this.activatedRoute.params);
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (testIdSubscription) => {
        // console.log(testIdSubscription);
        this.recievedTestId = testIdSubscription['testId'];
        if (
          this.recievedTestId !== -1 &&
          this.recievedTestId !== undefined &&
          this.recievedTestId !== null
        ) {
          this.getTest(this.recievedTestId);
          this.isInGet = true;
        } else {
          this.isInGet = false;
          // console.log('Invalid test ID');
          // this.notifier.notify('error', 'Invalid test ID');
        }
      }
    );
  }

  // typeset() {
  //   window.MathJax.typeset()
  // }

  getTest(testId: number) {
    this.globalApiService.getCreatedTest(testId).subscribe({
      next: (res: saveTestStruct) => {
        // console.log('getTest Response: ', res);
        this.isDataLoading = false;
        this.recievedTest = res;
        this.testId.patchValue(this.recievedTest.testCode);
        this.testName = this.recievedTest.testName;
        this.selectedTestType.patchValue(this.recievedTest.testTypeId);
        this.sortByModuleOrder();
        this.recievedTest.testModuleDetails.forEach(
          (testModule, testModuleIndex) => {
            testModule.moduleDuration = parseInt(
              (testModule.moduleDuration / 60).toFixed(0)
            );
            this.addSection();
            this.fillRecievedTestDetails(testModuleIndex);
          }
        );
        console.log('recieved Test --> : ', this.recievedTest);
        // this.getAndReplaceQuestionIdsWithQuestions();
        // this.paramSubscription.unsubscribe();
      },
      error: (err) => {
        console.log('getTest Error: ', err);
        this.notifier.notify('error', 'Unable to get test');
        this.isDataLoading = false;
      },
    });
  }

  getAndReplaceQuestionIdsWithQuestions(createdSectionIndex: number) {
    const test = this.recievedTest;
    // this.testId.patchValue(test.testCode);
    // this.testName = test.testName;
    // this.selectedTestType.patchValue(test.testTypeId);
    let count = 0;
    const testModule = this.recievedTest.testModuleDetails[createdSectionIndex];
    console.log(testModule);
    // this.sortByModuleOrder();
    // test.testModuleDetails.forEach((testModule, testModuleIndex) => {

    let questionIdsArr: number[] = [];
    let subTopicQuestionDetailCompareArr: any[] = [];
    let subTopicQuestionDetailArr: subTopicQuestionDetailNew[] = [];
    let joinedQuestionIds: string = '';
    testModule.questionsInfo.forEach(
      (questionInfoObj, questionInfoObjIndex) => {
        if (questionInfoObj.questionOrder === questionInfoObjIndex + 1) {
          let subTopicQuestionDetailCompareObj: any = {
            questionDetails: undefined,
            subTopicId: questionInfoObj.subTopicId,
            questionType: 0,
            difficultLevel: questionInfoObj.difficultyLevel,
            questionId: questionInfoObj.questionId,
          };
          subTopicQuestionDetailCompareArr.push(
            subTopicQuestionDetailCompareObj
          );
          questionIdsArr.push(questionInfoObj.questionId);
        }
      }
    );
    joinedQuestionIds = questionIdsArr.join(',');
    count = count + 1;
    // this.sortByModuleOrder();
    this.globalApiService.getMultipleQuestions(joinedQuestionIds).subscribe({
      next: (res: generatedQuestionObj[]) => {
        console.log('recieved questions: ', res);
        testModule.recievedQuestions = res;
        const orderedReceivedQuestions: generatedQuestionObj[] = [];
        testModule.questionsInfo.forEach((questionInfoObj) => {
          const resQuestionIndex = res.findIndex((resObj) => {
            return questionInfoObj.questionId === resObj.question.questionId;
          });
          if (resQuestionIndex >= 0) {
            orderedReceivedQuestions.push(res[resQuestionIndex]);
          }
        });
        console.log(orderedReceivedQuestions);
        orderedReceivedQuestions.forEach(
          (orderedReceivedQuestion, orderedReceivedQuestionIndex) => {
            subTopicQuestionDetailCompareArr.forEach(
              (subTopicQuestionCompDetail, subTopicQUestionCompDetailIndex) => {
                if (
                  orderedReceivedQuestion.question.questionId ===
                  subTopicQuestionCompDetail.questionId
                ) {
                  // console.log(
                  //   this.createdSections[testModuleIndex].sectionType
                  // );
                  let subTopicList =
                    this.scoringSectionWithSubTopics![
                      this.createdSections[createdSectionIndex].sectionType
                      // testModule.scoringSectionId
                    ];
                  let foundSubTopic = subTopicList.find(
                    (subTopic) =>
                      subTopic.subTopicId ===
                      subTopicQuestionCompDetail.subTopicId
                  );
                  let subTopicQuestionDetailObj: subTopicQuestionDetailNew = {
                    questionDetails: orderedReceivedQuestion,
                    subTopicId: subTopicQuestionCompDetail.subTopicId,
                    questionType: orderedReceivedQuestion.question.questionType,
                    difficultLevel: subTopicQuestionCompDetail.difficultLevel,
                  };
                  subTopicQuestionDetailObj.subTopicName = foundSubTopic
                    ? foundSubTopic.subTopicName.length > 0
                      ? foundSubTopic.subTopicName
                      : 'N/A'
                    : 'N/A';
                  subTopicQuestionDetailArr.push(subTopicQuestionDetailObj);
                }
              }
            );
          }
        );
        testModule.recievedQuestions = orderedReceivedQuestions;
        res.forEach((resObj, resobjIndex) => {
          testModule.questionsInfo.forEach(
            (questionInfoObj, questionInfoObjIndex) => {
              if (resObj.question.questionId === questionInfoObj.questionId) {
                resObj.moduleQuestionId = questionInfoObj.moduleQuestionId;
              }
            }
          );
        });
        // this.generatedDisplayModules[testModuleIndex].generatedQuestions = res;
        this.createdSections[createdSectionIndex].generatedQuestions =
          subTopicQuestionDetailArr;

        // TODO: Discuss this
        // this.createdSections[createdSectionIndex].generatedQuestions.forEach(
        //   (generatedQuestion, generatedQuestionIndex) => {
        //     this.loadTikzForEdit(createdSectionIndex, generatedQuestionIndex);
        //   }
        // );

        testModule.subTopicQuestionDetails.forEach(
          (subTopicDetail, subTopicDetailIndex) => {
            subTopicDetail.questionSpecifications.forEach(
              (questionSpec, questionSpecIndex) => {
                questionSpec['questions'] = [];
                this.createdSections[
                  createdSectionIndex
                ].generatedQuestions.forEach(
                  (recievedQuestion, recievedQuestionIndex) => {
                    console.log(recievedQuestion);
                    if (
                      subTopicDetail.subTopicId ===
                        recievedQuestion.subTopicId &&
                      questionSpec.difficultLevel ===
                        recievedQuestion.difficultLevel &&
                      questionSpec.questionType ===
                        recievedQuestion.questionType
                    ) {
                      const subTopicQuestionDetailObj: subTopicQuestionDetailNew =
                        {
                          questionDetails: recievedQuestion.questionDetails,
                          subTopicId: recievedQuestion.subTopicId,
                          questionType: recievedQuestion.questionType,
                          difficultLevel: recievedQuestion.difficultLevel,
                          subTopicName: recievedQuestion.subTopicName,
                        };
                      questionSpec.questions?.push(subTopicQuestionDetailObj);
                    }
                  }
                );
              }
            );
          }
        );
        this.loadTikz();
        this.makeImages();
        this.makeOrUpdateModuleWiseQuestionTypeCount(
          createdSectionIndex,
          this.typeCountProcess[1]
        );
        // if (count === test.testModuleDetails.length) {
        //   this.makeImages();
        //   this.loadTikz();
        // }
        console.log(res);
        console.log(testModule);
        this.checkValidity();
        this.isDataLoading = false;
      },
      error: (err) => {
        console.log('recieved questions Error: ', err);
        this.isDataLoading = false;
      },
    });
    // });
    console.log(count);
    console.log(this.recievedTest);
    console.log(this.createdSections);
  }

  sortByModuleOrder() {
    this.recievedTest.testModuleDetails.sort((a, b) => {
      return a.moduleOrder - b.moduleOrder;
    });
    console.log(
      this.createdSections,
      this.generatedModuleWiseQuestionTypeData,
      this.generatedDisplayModules
    );
  }

  fillRecievedTestDetails(testModuleIndex: number) {
    const test = this.recievedTest;
    // test.testModuleDetails.forEach((testModule, testModuleIndex) => {
    let testModule = test.testModuleDetails[testModuleIndex];
    console.log(testModule);
    let createdSection = this.createdSections[testModuleIndex];
    // createdSection = createdSection as testCreationSection;
    let finalDataObj: generateQuestionStruct = {
      moduleName: testModule.moduleName,
      moduleId: createdSection?.moduleId!,
      subTopicQuestionDetails: testModule.subTopicQuestionDetails,
      canRepeatQuestions: testModule.canRepeatQuestions,
      moduleOrder: testModule.moduleOrder,
      ignoredQuestionCategories: testModule.ignoredQuestionCategories || [],
      // onlyTestQuestions: testModule.onlyUseTestQuestions,
      onlyExerciseQuestions: testModule.onlyExerciseQuestions,
      onlyQuizQuestions: testModule.onlyQuizQuestions,
    };
    // this.generateQuestionsFinalData.push(finalDataObj);
    createdSection.generateQuestionsStructPerModule?.push(finalDataObj);
    createdSection.subTopicQuestionDetails =
      finalDataObj.subTopicQuestionDetails;
    console.log(this.createdSections, finalDataObj, testModule);
    console.log(createdSection, testModuleIndex, testModule);
    // if (createdSection !== undefined) {
    createdSection.breakAfterModule = testModule.breakAfterModule;
    createdSection.breakDuration = testModule.breakDuration + ' ' + 'mins';
    createdSection.canBePaused = testModule.canPauseModule;
    createdSection.sectionName = testModule.moduleName;
    createdSection.sectionType = testModule.scoringSectionId;
    createdSection.totalDuration = testModule.moduleDuration + ' ' + 'mins';
    createdSection.id = testModule.id;
    createdSection.moduleOrder = testModule.moduleOrder;
    createdSection.onlyExerciseQuestions = testModule.onlyExerciseQuestions;
    createdSection.onlyQuizQuestions = testModule.onlyQuizQuestions;
    this.getSubTopicsByScoringAndTestId(testModuleIndex, true);
    // let displaySection = this.generatedDisplayModules[testModuleIndex];
    createdSection.canRepeatQuestions = testModule.canRepeatQuestions;
    createdSection.ignoredQuestionCategories =
      testModule.ignoredQuestionCategories || [];
    // createdSection.onlyTestQuestions = testModule.onlyUseTestQuestions;
    // displaySection.generatedQuestions = testModule.recievedQuestions;
    createdSection.moduleOrder = testModule.moduleOrder;
    createdSection.isValid = true;
    console.log(createdSection);
    console.log('display section: ', testModule, testModuleIndex);
    // });
  }

  getCourses() {
    this.globalApiService.getCourses().subscribe({
      next: (res: coursesRes) => {
        console.log(res);
        this.coursesList = res.data;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getTestTypes() {
    this.globalApiService.getTestTypes().subscribe({
      next: (res: testType[]) => {
        console.log(res);
        this.testTypesList = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  testTypeFinder(): testType | undefined {
    const selectedTestType = this.testTypesList.find(
      (testType) => testType.testTypeName == this.selectedTestType.value
    );
    return selectedTestType;
  }

  getTestSections() {
    // const selectedTestType: testType | undefined = this.testTypeFinder();
    this.globalApiService
      .getScoringSectionsByTestTypeId(this.selectedTestType.value)
      .subscribe({
        next: (res: scoringSectionResBeforeParse) => {
          console.log(res);
          let data: scoringSection[] = JSON.parse(res.data);
          console.log(data);
          this.scoringSectionsList = data;
        },
        error: (err) => {
          console.log(err);
          this.notifier.notify('error', 'Error fetching sub topics');
        },
      });
    // this.globalApiService
    //   .getSectionsByTestTypeId(this.selectedTestType.value)
    //   .subscribe({
    //     next: (res: scoringSectionResBeforeParse) => {
    //       console.log(res);
    //       let data: scoringSection[] = JSON.parse(res.data);
    //       console.log(data);
    //       this.scoringSectionsList = data;
    //     },
    //     error: (err) => {
    //       console.log(err);
    //       this.notifier.notify('error', 'Error fetching sub topics');
    //     },
    //   });
  }

  addSection() {
    console.log(this.selectedTestType);
    console.log(this.createdSections.length);
    if (this.selectedTestType.valid) {
      this.getTestSections();
      const newSection: testCreationSection = {
        sectionName: `Module`,
        sectionType: 'scoringSection',
        totalDuration: '30 mins',
        breakDuration: '0 mins',
        breakAfterModule: false,
        canBePaused: true,
        moduleId: this.createdSections.length + 1,
        id: '',
        moduleOrder: this.createdSections.length,
        isExistingSection: false,
        generatedQuestions: [],
        subTopicQuestionDetails: [],
        generateQuestionsStructPerModule: [],
        canRepeatQuestions: false,
        ignoredQuestionCategories: [],
        // onlyTestQuestions: false,
        onlyExerciseQuestions: false,
        onlyQuizQuestions: false,
        isValid: false,
        isTotalDurationValid: true,
        isBreakDurationValid: true,
        questionTypeCount: {
          totalQuestions: 0,
          totalFreetext: 0,
          totalMcqs: 0,
          generatedQuestions: 0,
          deletedQuestions: 0,
        },
      };
      this.createdSections.push(newSection);
      console.log(this.selectedTestType);
      let moduleValidObj: moduleValidity = {
        isValidQuesstionaire: false,
        moduleName: `Module ${this.moduleValidityList.length + 1}`,
        moduleId: newSection.moduleId,
      };
      this.moduleValidityList.push(moduleValidObj);
      this.checkValidity();
    } else {
      this.notifier.notify('error', 'Please select a course');
    }
  }

  getSubTopicsByScoringAndTestId(sectionIndex: number, isReplace: boolean) {
    const createdSection = this.createdSections[sectionIndex];
    let getSubTopics = true;
    if (
      this.scoringSectionWithSubTopics &&
      this.scoringSectionWithSubTopics[createdSection.sectionType]
    ) {
      getSubTopics = false;
    }
    if (getSubTopics) {
      console.log(createdSection.sectionType);
      this.globalApiService
        .getSubTopicsByScoringAndTestId(
          createdSection.sectionType as number,
          this.selectedTestType.value
        )
        .subscribe({
          next: (res: subTopicByScoringAndTestId[]) => {
            if (this.scoringSectionWithSubTopics) {
              this.scoringSectionWithSubTopics[createdSection.sectionType] =
                res;
            } else {
              this.scoringSectionWithSubTopics = {
                [createdSection.sectionType]: res,
              };
            }
            if (isReplace) {
              this.getAndReplaceQuestionIdsWithQuestions(sectionIndex);
            }
          },
          error: (err) => {
            // console.log(err);
            this.notifier.notify('error', 'Unable to fetch subtopics');
          },
        });
    }
  }

  changeAllModuleNames(moduleId: number) {
    // console.log(this.createdSections);
    let createdSection = this.createdSections.find(
      (createdSection) => createdSection.moduleId === moduleId
    );
    let createdSectionName = (createdSection as testCreationSection)
      .sectionName;
    let generatedDisplayModule = this.generatedDisplayModules.find(
      (generatedDisplayModule) => generatedDisplayModule.moduleId === moduleId
    );
    let generatedFinalData = this.generateQuestionsFinalData.find(
      (generatedFinalObj) => generatedFinalObj.moduleId === moduleId
    );
    // let generatedModuleWiseDataObj =
    //   this.generatedModuleWiseQuestionTypeData.find(
    //     (generatedModuleWiseQuestionObj) =>
    //       generatedModuleWiseQuestionObj.moduleId === moduleId
    //   );
    let moduleValidObj = this.moduleValidityList.find((moduleValid) => {
      moduleValid.moduleId === moduleId;
    });
    if (generatedDisplayModule) {
      (generatedDisplayModule as displayGeneratedModule).moduleName =
        createdSectionName;
    }
    // if (generatedModuleWiseDataObj) {
    //   (generatedModuleWiseDataObj as moduleWiseQuestionsTypeCount).moduleName =
    //     createdSectionName;
    // }
    if (generatedFinalData) {
      (generatedFinalData as generateQuestionStruct).moduleName =
        createdSectionName;
    }
    if (moduleValidObj) {
      (moduleValidObj as moduleValidity).moduleName = createdSectionName;
    }
    console.log(
      this.generatedDisplayModules,
      this.generatedModuleWiseQuestionTypeData,
      this.generateQuestionsFinalData,
      this.moduleValidityList
    );
  }

  changeCreatedSectionPosition(isUp: boolean, sectionIndex: number) {
    const secondIndex = sectionIndex + (isUp ? -1 : 1);
    const firstSection = this.createdSections[sectionIndex];
    const secondSection = this.createdSections[secondIndex];
    const firstModuleOrder = firstSection.moduleOrder;
    const secondModuleOrder = secondSection.moduleOrder;
    firstSection.moduleOrder = secondModuleOrder;
    secondSection.moduleOrder = firstModuleOrder;
    this.createdSections[sectionIndex] = secondSection;
    this.createdSections[secondIndex] = firstSection;
    if (this.currentSection === sectionIndex) {
      this.currentSection = secondIndex;
    } else if (this.currentSection === secondIndex) {
      this.currentSection = sectionIndex;
    }
  }

  changeQuestionPosition(
    isUp: boolean,
    moduleIndex: number,
    questionIndex: number
  ) {
    const secondIndex = questionIndex + (isUp ? -1 : 1);
    const questions = this.createdSections[moduleIndex].generatedQuestions;
    const firstQuestion = questions[questionIndex];
    const secondQuestion = questions[secondIndex];
    questions[questionIndex] = secondQuestion;
    questions[secondIndex] = firstQuestion;
  }

  changeDurationText(
    isFocused: boolean,
    isTotalDuration: boolean,
    indexAttached: number
  ) {
    let elementId: string = isTotalDuration
      ? `totalDuration-${indexAttached}`
      : `breakDuration-${indexAttached}`;
    let inputEle: HTMLInputElement = document.getElementById(
      elementId
    ) as HTMLInputElement;
    console.log(inputEle.value);
    let createdSection: testCreationSection =
      this.createdSections[indexAttached];
    let duration: string | number = isTotalDuration
      ? createdSection.totalDuration.toString().split(' ')[0]
      : createdSection.breakDuration.toString().split(' ')[0];
    let retDuration: string | number = isFocused
      ? duration
      : duration + ' mins';
    // inputEle.value = retDuration as string;
    if (isFocused) {
      inputEle.value = retDuration as string;
    } else {
      if (isTotalDuration) {
        createdSection.totalDuration =
          inputEle.value === '' ? '0 mins' : inputEle.value + ' mins';
      } else {
        createdSection.breakDuration =
          inputEle.value === '' ? '0 mins' : inputEle.value + ' mins';
      }
      inputEle.value = inputEle.value + ' mins';
    }
    console.log(createdSection);
    console.log(this.createdSections);
    this.checkValidity();
  }

  getOnlyDuration() {
    this.createdSections.forEach((createdSection, createdSectionIndex) => {
      let totalDuration = createdSection.totalDuration.toString();
      let breakDuration = createdSection.breakDuration.toString();
      createdSection.totalDuration = totalDuration.split(' ')[0];
      createdSection.breakDuration = breakDuration.split(' ')[0];
    });
    console.log(this.createdSections);
  }

  checkInputValidity(
    event: any,
    createdSectionIndex: number,
    isTotalDuration: boolean
  ) {
    const inputValue = event.target.value;
    console.log(inputValue);
    const regex = /^[0-9]*$/;
    if (!regex.test(inputValue) || inputValue === '' || inputValue < 1) {
      if (isTotalDuration) {
        this.createdSections[createdSectionIndex].isTotalDurationValid = false;
      } else {
        this.createdSections[createdSectionIndex].isBreakDurationValid = false;
      }
    } else {
      if (isTotalDuration) {
        this.createdSections[createdSectionIndex].isTotalDurationValid = true;
      } else {
        this.createdSections[createdSectionIndex].isBreakDurationValid = true;
      }
    }
    this.checkValidity();
  }

  checkDurationValidity(
    isTotalDuration: boolean,
    sectionIndex: number
  ): boolean {
    let elementId: string = isTotalDuration
      ? `totalDuration-${sectionIndex}`
      : `breakDuration-${sectionIndex}`;
    let inputEle: HTMLInputElement = document.getElementById(
      elementId
    ) as HTMLInputElement;
    let createdSection = this.createdSections[sectionIndex];
    let totalDuration = createdSection.totalDuration.toString();
    let breakDuration = createdSection.breakDuration.toString();
    if (isTotalDuration) {
      try {
        let parsedTotalDuration = parseInt(totalDuration);
        console.log(parsedTotalDuration);
        if (parsedTotalDuration < 0 || Number.isNaN(parsedTotalDuration)) {
          return false;
        } else {
          return true;
        }
      } catch (error) {
        return false;
      }
    } else {
      try {
        let parsedBreakDuration = parseInt(breakDuration);
        if (parsedBreakDuration < 0 || Number.isNaN(parsedBreakDuration)) {
          return false;
        } else {
          return true;
        }
      } catch (error) {
        return false;
      }
    }
  }

  checkValidity() {
    if (this.createdSections.length > 0) {
      this.createdSections.forEach((createdSection, createdSectionIndex) => {
        console.log(createdSection.questionTypeCount);
        if (
          (createdSection.questionTypeCount.totalQuestions === 0 &&
            createdSection.questionTypeCount.totalQuestions ===
              createdSection.questionTypeCount.generatedQuestions) ||
          createdSection.questionTypeCount.totalQuestions !==
            createdSection.questionTypeCount.generatedQuestions ||
          createdSection.sectionName === '' ||
          !createdSection.isTotalDurationValid ||
          (createdSection.breakAfterModule &&
            !createdSection.isBreakDurationValid)
        ) {
          createdSection.isValid = false;
        } else {
          createdSection.isValid = true;
        }
      });

      let foundInvalidModule = this.createdSections.find(
        (validModule) => validModule.isValid === false
      );
      console.log(this.createdSections);
      if (foundInvalidModule) {
        console.log('in if');
        this.isValidQuesstionaire = false;
        this.isSaveValid = false;
      } else {
        console.log('in else');
        this.isValidQuesstionaire = true;
        this.isSaveValid = this.testId.valid;
      }
      console.log(this.isValidQuesstionaire, this.isSaveValid);
    } else {
      this.isSaveValid = false;
    }
  }

  addErrorClass(sectionIndex: number): boolean {
    let isValid = false;
    let createdSection = this.createdSections[sectionIndex];
    let foundModuleValidObj = this.moduleValidityList.find((moduleValidObj) => {
      moduleValidObj.moduleId === createdSection.moduleId;
    });
    if (foundModuleValidObj) {
      if (foundModuleValidObj.isValidQuesstionaire) {
        isValid = true;
      }
    }
    return isValid;
  }

  openQuestionDistributionPattern(createdSectionIndex: number) {
    console.log(this.subTopicsByScoringAndTestIdList);
    console.log(this.createdSections[createdSectionIndex]);
    if (
      this.createdSections[createdSectionIndex].sectionType === 'scoringSection'
    ) {
      this.notifier.notify('error', 'Please select a scoring section');
    } else if (!this.scoringSectionWithSubTopics) {
      this.notifier.notify('error', 'Subtopics not found');
    } else {
      let createdSection = this.createdSections[createdSectionIndex];
      let foundSubTopicListByModule = this.subTopicsByScoringAndTestIdList.find(
        (subTopicsByScoringAndTestId) =>
          subTopicsByScoringAndTestId.moduleId === createdSection.moduleId
      );
      if (
        this.scoringSectionWithSubTopics[createdSection.sectionType]?.length! >
        0
      ) {
        let data: moduleSubTopic = {
          moduleName: createdSection.sectionName,
          moduleSubTopics:
            this.scoringSectionWithSubTopics[createdSection.sectionType],
          canRepeatQuestions: createdSection.canRepeatQuestions,
          // onlyTestQuestions: createdSection.onlyTestQuestions,
          onlyExerciseQuestions:
            !createdSection.ignoredQuestionCategories.includes(
              'EXCERSIZE_QUESTION'
            ),
          onlyQuizQuestions:
            !createdSection.ignoredQuestionCategories.includes('QUIZ_QUESTION'),
          existingQuestionDistributionPatterns:
            createdSection.subTopicQuestionDetails,
          questionsCount: createdSection.questionTypeCount,
          moduleId: createdSection.moduleId,
        };
        const dialogRef = this.matDialog.open(
          QuestionDistributionPatternComponent,
          {
            data: data,
            panelClass: 'questionDistributionPattern',
          }
        );
        dialogRef.afterClosed().subscribe((result: quesDistributionPattern) => {
          console.log(result);
          if (result?.questionStructList?.length > 0) {
            this.isValidQuesstionaire = result.isValidQuestionnaire;
            createdSection.isValid = result.isValidQuestionnaire;
            console.log(result);
            // this.generateQuestionsFinalData = result;
            createdSection.subTopicQuestionDetails =
              result.questionStructList[0].subTopicQuestionDetails;
            createdSection.canRepeatQuestions =
              result.questionStructList[0].canRepeatQuestions;
            createdSection.ignoredQuestionCategories =
              result.questionStructList[0].ignoredQuestionCategories;
            // createdSection.onlyTestQuestions =
            //   result.questionStructList[0].onlyTestQuestions;
            createdSection.onlyExerciseQuestions =
              result.questionStructList[0].onlyExerciseQuestions;
            createdSection.onlyQuizQuestions =
              result.questionStructList[0].onlyQuizQuestions;
            createdSection.generateQuestionsStructPerModule =
              result.questionStructList;
            this.generateQuestionsOnlyForThisModule = result.questionStructList;
            createdSection.generatedQuestions = [];
            let questionsContainerBySubTopicId: subTopicQuestionDetailNew[][] =
              [];
            createdSection.subTopicQuestionDetails.forEach(
              (subTopicDetail, subTopicDetailIndex) => {
                subTopicDetail.questionSpecifications.forEach(
                  (quesSpec, quesSpecIndex) => {
                    // ** logic for subTopic Name
                    quesSpec.questions?.forEach((question, questionIndex) => {
                      let subTopicList =
                        this.scoringSectionWithSubTopics![
                          createdSection.sectionType
                        ];
                      let foundSubTopic = subTopicList.find(
                        (subTopic) =>
                          subTopic.subTopicId === question.subTopicId
                      );
                      question.subTopicName = foundSubTopic
                        ? foundSubTopic.subTopicName.length > 0
                          ? foundSubTopic.subTopicName
                          : 'N/A'
                        : 'N/A';
                    });
                    console.log(quesSpec);
                    // createdSection.generatedQuestions.push(
                    //   ...quesSpec.questions!
                    // );
                  }
                );
                // let filterQuestionsBySubTopicIdArr =
                //   createdSection.generatedQuestions.filter(
                //     (question) =>
                //       question.subTopicId === subTopicDetail.subTopicId
                //   );
                // questionsContainerBySubTopicId.push(
                //   filterQuestionsBySubTopicIdArr
                // );
              }
            );
            // questionsContainerBySubTopicId.sort(
            //   (questionsArr1, questionsArr2) =>
            //     questionsArr2.length - questionsArr1.length
            // );
            // console.log(questionsContainerBySubTopicId);
            // let maxQuestionsLength = questionsContainerBySubTopicId[0].length;
            // let whileIterate = 0;
            // let generatedQuestionsArr: subTopicQuestionDetailNew[] = [];
            // while (whileIterate < maxQuestionsLength) {
            //   for (let i = 0; i < questionsContainerBySubTopicId.length; i++) {
            //     let questionsArr = questionsContainerBySubTopicId[i];
            //     if (whileIterate < questionsArr.length) {
            //       generatedQuestionsArr.push(questionsArr[whileIterate]);
            //     }
            //   }
            //   whileIterate++;
            // }
            // console.log(generatedQuestionsArr);
            createdSection.generatedQuestions =
              result.questionStructList[0].generatedQuestions!;
            this.makeOrUpdateModuleWiseQuestionTypeCount(
              createdSectionIndex,
              this.typeCountProcess[2]
            );
            this.makeImages();
            this.loadTikz();
            this.checkValidity();
            // this.generateQuestionsAPI(
            //   result.questionStructList,
            //   createdSectionIndex
            // );
          } else {
            // if (this.isInGet) {
            //   this.isValidQuesstionaire = true;
            // } else {
            //   this.isValidQuesstionaire = false;
            // }
            this.checkValidity();
          }
        });
      } else {
        this.notifier.notify('error', 'Error fetching sub topics');
      }
    }
  }

  disableRegenerateButton(moduleIndex: number): boolean {
    let isDisabled: boolean = false;
    let regenerateModuleObj = this.generateQuestionsFinalData.find(
      (generateQuestionFinalObj, generateQuestionFinalObjIndex) =>
        generateQuestionFinalObj.moduleId ===
        this.generatedDisplayModules[moduleIndex].moduleId
    );
    if (!regenerateModuleObj) {
      isDisabled = true;
    } else {
      isDisabled = false;
    }
    return isDisabled;
  }

  regenerateQuestions(moduleIndex: number) {
    this.createdSections[moduleIndex].generatedQuestions = [];
    this.generateQuestionsAPI(
      this.createdSections[moduleIndex].generateQuestionsStructPerModule!,
      moduleIndex
    );
    // this.checkValidity();
  }

  generateQuestionsAPI(
    generateQuestionsPerModule: generateQuestionStruct[],
    sectionIndex: number
  ) {
    this.currentSection = sectionIndex;
    this.generatingQuestions = true;
    this.generatedModules = [];
    // this.checkValidity();
    // this.generatedDisplayModules = [];
    console.log(this.generateQuestionsFinalData);
    this.globalApiService
      .getQuestionsGeneratedNew(generateQuestionsPerModule)
      .subscribe({
        next: (res: generateQuestionStructNew[]) => {
          console.log(res);
          // for (let moduleIndex = 0; moduleIndex < res.length; moduleIndex++) {
          //   this.generatedModules.push(res[moduleIndex]);
          // }
          // TODO: Ask backend API to update the response for this prepareQuestionary API with a unique ID
          this.generatedModules = res;
          //
          const displayModuleObjIndex = this.currentSection;
          const displayModuleObj = this.createdSections[displayModuleObjIndex];
          console.log(displayModuleObj);
          // ** Used to empty the array before pushing newly generated questions to old ones
          displayModuleObj!.generatedQuestions = [];
          displayModuleObj.subTopicQuestionDetails.forEach(
            (subTopicDetail, subTopicDetailIndex) => {
              subTopicDetail.questionSpecifications.forEach(
                (quesSpec, quesSpecIndex) => {
                  quesSpec.questions = [];
                }
              );
              res.forEach((generatedModule) => {
                generatedModule.subTopicQuestionDetails.forEach(
                  (subTopicQuestionDetail, subTopicQuestionDetailIndex) => {
                    if (
                      subTopicQuestionDetail.subTopicId ===
                      subTopicDetail.subTopicId
                    ) {
                      subTopicDetail.questionSpecifications.forEach(
                        (quesSpec, quesSpecIndex) => {
                          if (
                            quesSpec.difficultLevel ===
                              subTopicQuestionDetail.difficultLevel &&
                            quesSpec.questionType ===
                              subTopicQuestionDetail.questionType
                          ) {
                            quesSpec.questions?.push(subTopicQuestionDetail);
                            quesSpec.questions?.forEach(
                              (question, questionIndex) => {
                                let subTopicList =
                                  this.scoringSectionWithSubTopics![
                                    displayModuleObj.sectionType
                                  ];
                                let foundSubTopic = subTopicList.find(
                                  (subTopic) =>
                                    subTopic.subTopicId === question.subTopicId
                                );
                                question.subTopicName = foundSubTopic
                                  ? foundSubTopic.subTopicName.length > 0
                                    ? foundSubTopic.subTopicName
                                    : 'N/A'
                                  : 'N/A';
                              }
                            );
                            // displayModuleObj?.generatedQuestions.push(
                            //   subTopicQuestionDetail
                            // );
                          }
                        }
                      );
                    }
                  }
                );
              });
            }
          );
          res.forEach((generatedModule) => {
            // displayModuleObj!.generatedQuestions = generatedModule.questions
            generatedModule.subTopicQuestionDetails.forEach(
              (subTopicDetail) => {
                displayModuleObj?.generatedQuestions.push(subTopicDetail);
              }
            );
            console.log(displayModuleObj);
            this.generatingQuestions = false;
            this.makeImages();
            this.loadTikz();
            this.makeOrUpdateModuleWiseQuestionTypeCount(
              displayModuleObjIndex,
              this.typeCountProcess[2]
            );
            this.checkValidity();
          });
          console.log(this.generatedDisplayModules);
        },
        error: (err) => {
          console.log(err);
          this.notifier.notify(
            'error',
            'Error fetching the generated questions'
          );
        },
      });
  }

  makeOrUpdateModuleWiseQuestionTypeCount(
    moduleIndex: number,
    process: string,
    subTopicId?: number,
    difficultyLevel?: number,
    questionType?: number
  ) {
    // ** For Reference - typeCountProcess: string[] = ['Update', 'Generate', 'Remove'];
    let finalDataObj: testCreationSection = this.createdSections[moduleIndex];
    let moduleWiseQuestionTypeCountObj = finalDataObj.questionTypeCount;

    moduleWiseQuestionTypeCountObj!.generatedQuestions =
      finalDataObj.generatedQuestions.length;

    if (
      process === this.typeCountProcess[1] ||
      process === this.typeCountProcess[2]
    ) {
      moduleWiseQuestionTypeCountObj!.totalQuestions = 0;
      moduleWiseQuestionTypeCountObj!.deletedQuestions = 0;
    } else if (process === this.typeCountProcess[3]) {
      ++this.createdSections[moduleIndex].questionTypeCount.deletedQuestions;
    }
    console.log(finalDataObj, finalDataObj.subTopicQuestionDetails);
    finalDataObj?.subTopicQuestionDetails.forEach((subTopicQuestionDetail) => {
      console.log(subTopicQuestionDetail);
      // moduleWiseQuestionTypeCountObj!.totalQuestions =
      //   moduleWiseQuestionTypeCountObj!.totalQuestions +
      subTopicQuestionDetail.questionSpecifications.forEach(
        (quesSpec, quesSpecIndex) => {
          if (
            process === this.typeCountProcess[1] ||
            process === this.typeCountProcess[2]
          ) {
            moduleWiseQuestionTypeCountObj!.totalQuestions =
              moduleWiseQuestionTypeCountObj!.totalQuestions +
              quesSpec.noOfQuestions;
          }
          quesSpec.presentQuestions =
            process === this.typeCountProcess[1]
              ? quesSpec.noOfQuestions
              : quesSpec.questions?.length;
          quesSpec.deletedQuestions =
            process === this.typeCountProcess[1] ||
            process === this.typeCountProcess[2]
              ? 0
              : subTopicId === subTopicQuestionDetail.subTopicId &&
                quesSpec.difficultLevel === difficultyLevel &&
                quesSpec.questionType === questionType
              ? ++quesSpec.deletedQuestions!
              : quesSpec.deletedQuestions! > 0
              ? quesSpec.deletedQuestions
              : 0;
        }
      );
    });

    moduleWiseQuestionTypeCountObj!.totalMcqs = 0;

    moduleWiseQuestionTypeCountObj!.totalFreetext = 0;

    finalDataObj.generatedQuestions.forEach((genQues, genQuesIndex) => {
      if (genQues.questionType === 1) {
        ++moduleWiseQuestionTypeCountObj!.totalMcqs;
      } else if (genQues.questionType === 2) {
        ++moduleWiseQuestionTypeCountObj!.totalFreetext;
      }
    });
    console.log(finalDataObj?.subTopicQuestionDetails);
    // console.log(this.generatedDisplayModules);
    // console.log(this.generatedModuleWiseQuestionTypeData);
  }

  getImages(listOfImages: string[]) {
    this.globalApiService.getImages(listOfImages).subscribe(
      (response: any) => {
        console.log(response);
        const data = response.data;
        if (data) {
          this.images = { ...this.images, ...data };
        }
        console.log(this.images);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  makeImages() {
    let listOfImages: string[] = [];
    this.createdSections.forEach((generatedDisplayModule) => {
      generatedDisplayModule.generatedQuestions.forEach(
        (generatedQuestionsObj) => {
          // ** For choices (MCQ's)
          generatedQuestionsObj.questionDetails.choices?.forEach((choice) => {
            // ** For choices (Explanations)
            choice.explanation?.forEach((explanation) => {
              if (explanation.type === 'Images') {
                explanation['images'] = JSON.parse(explanation.data);
                listOfImages.push(...(explanation['images'] as string[]));
              }
            });
            // ** For choices Options
            choice.optionValue.forEach((choiceData) => {
              if (choiceData.type === 'Images') {
                choiceData['images'] = JSON.parse(choiceData.data);
                listOfImages.push(...(choiceData['images'] as string[]));
              }
            });
          });
          // ** For answers (Freetext) - Explanaions
          generatedQuestionsObj.questionDetails.answers?.explanation.forEach(
            (freetextExplanation) => {
              if (freetextExplanation.type === 'Images') {
                freetextExplanation['images'] = JSON.parse(
                  freetextExplanation.data
                );
                listOfImages.push(
                  ...(freetextExplanation['images'] as string[])
                );
              }
            }
          );
          // ** For questions
          generatedQuestionsObj.questionDetails.question.questionData.forEach(
            (questionDataObj) => {
              if (questionDataObj.type === 'Images') {
                questionDataObj['images'] = JSON.parse(questionDataObj.data);
                listOfImages.push(...(questionDataObj['images'] as string[]));
              }
            }
          );
        }
      );
    });
    this.getImages(listOfImages);
  }

  delayTikz(index: number, totaltikZ: TikZType[]) {
    setTimeout(() => {
      console.log(index, totaltikZ[index]);
      new update(totaltikZ[index].data, totaltikZ[index].id);
      index++;
      if (index < totaltikZ.length) {
        this.delayTikz(index, totaltikZ);
      }
    }, 1000);
  }

  loadTikz() {
    const totaltikZ: TikZType[] = [];
    this.createdSections.forEach((section, sectionIndex) => {
      section.generatedQuestions.forEach(
        (generatedQuestion, generatedQuestionIndex) => {
          // ** tikz for questions
          generatedQuestion.questionDetails.question.questionData.forEach(
            (questionInfo, questionInfoIndex) => {
              if (questionInfo.type === 'TikZ') {
                totaltikZ.push({
                  id:
                    'generatedQuestion-' +
                    sectionIndex +
                    '-' +
                    generatedQuestionIndex +
                    '-' +
                    questionInfoIndex,
                  data: questionInfo.data,
                });
              }
            }
          );
          // ** tikz for freetext answer - explanations
          // generatedQuestion.questionDetails.answers?.explanation.forEach(
          //   (freetextExplanation, freetextExplanationIndex) => {
          //     if (freetextExplanation.type === 'TikZ') {
          //       totaltikZ.push({
          //         id:
          //           'generatedFreetextExplanation-' +
          //           sectionIndex +
          //           '-' +
          //           generatedQuestionIndex +
          //           '-' +
          //           freetextExplanationIndex,
          //         data: freetextExplanation.data,
          //       });
          //     }
          //   }
          // );
          // ** tikz for choices (options and explanations)
          generatedQuestion.questionDetails.choices?.forEach(
            (mcqChoice, mcqChoiceIndex) => {
              // ** tikz for explanations in choices
              // mcqChoice.explanation?.forEach(
              //   (mcqChoiceExplanation, mcqChoiceExplanationIndex) => {
              //     if (mcqChoiceExplanation.type === 'TikZ') {
              //       totaltikZ.push({
              //         id:
              //           'generatedChoiceExplanation-' +
              //           sectionIndex +
              //           '-' +
              //           generatedQuestionIndex +
              //           '-' +
              //           mcqChoiceIndex +
              //           '-' +
              //           mcqChoiceExplanationIndex,
              //         data: mcqChoiceExplanation.data,
              //       });
              //     }
              //   }
              // );
              mcqChoice.optionValue.forEach(
                (mcqChoiceOption, mcqChoiceOptionIndex) => {
                  if (mcqChoiceOption.type === 'TikZ') {
                    totaltikZ.push({
                      id:
                        'generatedChoiceOption-' +
                        sectionIndex +
                        '-' +
                        generatedQuestionIndex +
                        '-' +
                        mcqChoiceIndex +
                        '-' +
                        mcqChoiceOptionIndex,
                      data: mcqChoiceOption.data,
                    });
                  }
                }
              );
            }
          );
        }
      );
    });
    console.log(totaltikZ);
    if (totaltikZ.length > 0) {
      this.delayTikz(0, totaltikZ);
    }
  }

  loadTikzForEdit(sectionIndex: number, generatedQuestionIndex: number) {
    // const totaltikZ: TikZType[] = [];
    // this.createdSections.forEach((section, sectionIndex) => {
    // section.generatedQuestions.forEach(
    //   (generatedQuestion, generatedQuestionIndex) => {
    let generatedQuestion =
      this.createdSections[sectionIndex].generatedQuestions[
        generatedQuestionIndex
      ];
    // ** tikz for questions
    generatedQuestion.questionDetails.question.questionData.forEach(
      (questionInfo, questionInfoIndex) => {
        if (questionInfo.type === 'TikZ') {
          this.totaltikZ.push({
            id:
              'generatedQuestion-' +
              sectionIndex +
              '-' +
              generatedQuestionIndex +
              '-' +
              questionInfoIndex,
            data: questionInfo.data,
          });
        }
      }
    );
    // ** tikz for freetext answer - explanations
    // generatedQuestion.questionDetails.answers?.explanation.forEach(
    //   (freetextExplanation, freetextExplanationIndex) => {
    //     if (freetextExplanation.type === 'TikZ') {
    //       totaltikZ.push({
    //         id:
    //           'generatedFreetextExplanation-' +
    //           sectionIndex +
    //           '-' +
    //           generatedQuestionIndex +
    //           '-' +
    //           freetextExplanationIndex,
    //         data: freetextExplanation.data,
    //       });
    //     }
    //   }
    // );
    // ** tikz for choices (options and explanations)
    generatedQuestion.questionDetails.choices?.forEach(
      (mcqChoice, mcqChoiceIndex) => {
        // ** tikz for explanations in choices
        // mcqChoice.explanation?.forEach(
        //   (mcqChoiceExplanation, mcqChoiceExplanationIndex) => {
        //     if (mcqChoiceExplanation.type === 'TikZ') {
        //       totaltikZ.push({
        //         id:
        //           'generatedChoiceExplanation-' +
        //           sectionIndex +
        //           '-' +
        //           generatedQuestionIndex +
        //           '-' +
        //           mcqChoiceIndex +
        //           '-' +
        //           mcqChoiceExplanationIndex,
        //         data: mcqChoiceExplanation.data,
        //       });
        //     }
        //   }
        // );
        mcqChoice.optionValue.forEach(
          (mcqChoiceOption, mcqChoiceOptionIndex) => {
            if (mcqChoiceOption.type === 'TikZ') {
              this.totaltikZ.push({
                id:
                  'generatedChoiceOption-' +
                  sectionIndex +
                  '-' +
                  generatedQuestionIndex +
                  '-' +
                  mcqChoiceIndex +
                  '-' +
                  mcqChoiceOptionIndex,
                data: mcqChoiceOption.data,
              });
            }
          }
        );
      }
    );
    //   }
    // );
    // });
    console.log(this.totaltikZ);
    if (this.totaltikZ.length > 0) {
      setTimeout(() => {
        this.delayTikz(0, this.totaltikZ);
      }, 1000);
    }
  }

  getOptionText(optionIndex: number): string {
    let returnOptionText = this.options[optionIndex];
    return returnOptionText;
  }

  removeSectionOrQuestion(
    moduleIndex: number,
    questionIndex: number,
    isQuestion: boolean
  ) {
    let dataToBeSentToModal: deleteQuestionOrSectionConfirmation = isQuestion
      ? {
          isQuestion: isQuestion,
          moduleIndex: moduleIndex,
          questionInfo:
            this.createdSections[moduleIndex].generatedQuestions[questionIndex],
        }
      : { isQuestion: isQuestion, moduleIndex: moduleIndex };
    const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
      data: dataToBeSentToModal,
      panelClass: 'confirmation',
    });
    dialogRef
      .afterClosed()
      .subscribe((dataToBeDeleted: deleteQuestionOrSectionConfirmation) => {
        if (dataToBeDeleted) {
          const createdSection = this.createdSections[moduleIndex];
          if (isQuestion) {
            // this.generatedDisplayModules[moduleIndex].generatedQuestions.splice(
            //   questionIndex,
            //   1
            // );
            createdSection.generatedQuestions.splice(questionIndex, 1);
            createdSection.subTopicQuestionDetails.forEach(
              (subTopicQuestionDetail, subTopicQuestionDetailIndex) => {
                if (
                  subTopicQuestionDetail.subTopicId ===
                  dataToBeDeleted.questionInfo?.subTopicId
                ) {
                  let foundSpec =
                    subTopicQuestionDetail.questionSpecifications.find(
                      (quesSpec) =>
                        quesSpec.difficultLevel ===
                          dataToBeDeleted.questionInfo?.difficultLevel &&
                        quesSpec.questionType ===
                          dataToBeDeleted.questionInfo?.questionType
                    );
                  if (foundSpec) {
                    console.log('difficulty level matches');
                    foundSpec.questions = foundSpec.questions?.filter(
                      (ques) =>
                        ques.questionDetails.question.questionId !==
                        dataToBeDeleted.questionInfo?.questionDetails.question
                          .questionId
                    );
                  }
                }
              }
            );
            console.log(
              dataToBeDeleted,
              createdSection.subTopicQuestionDetails
            );
            this.notifier.notify(
              'success',
              'Question has been successfully deleted'
            );
            this.makeOrUpdateModuleWiseQuestionTypeCount(
              moduleIndex,
              this.typeCountProcess[3],
              dataToBeDeleted.questionInfo?.subTopicId,
              dataToBeDeleted.questionInfo?.difficultLevel,
              dataToBeDeleted.questionInfo?.questionType
            );
            this.checkValidity();
            console.log(this.generatedDisplayModules);
            console.log(this.createdSections);
          } else if (!isQuestion) {
            this.createdSections.splice(moduleIndex, 1);
            this.notifier.notify(
              'success',
              'Section has been successfully deleted'
            );
            this.checkValidity();
          }
        } else {
          console.log('not deleted');
        }
      });
  }

  makePresentQuestionIds(moduleIndex: number) {
    this.presentQuestionIds = [];
    this.createdSections[moduleIndex].generatedQuestions.forEach(
      (generatedQuestion, generatedQuestionIndex) => {
        // TODO: Confirm whether each questionId is different irrespective of subTopicId
        // generatedQuestion.questionTestTypes[0].subTopicId
        this.presentQuestionIds.push(
          generatedQuestion.questionDetails.question.questionId
        );
      }
    );
    console.log(this.presentQuestionIds);
  }

  manualReplace(moduleIndex: number, questionIndex: number) {
    this.makePresentQuestionIds(moduleIndex);
    console.log(this.createdSections);
    const currentQuestion =
      this.createdSections[moduleIndex].generatedQuestions[questionIndex];
    const dialogRef = this.matDialog.open(ManualReplaceDialogComponent, {
      data: {
        questionIds: this.presentQuestionIds,
        moduleIndex: moduleIndex,
        questionIndex: questionIndex,
        questionInfo:
          this.createdSections[moduleIndex].generatedQuestions[questionIndex],
        canRepeatQuestions:
          this.createdSections[moduleIndex].canRepeatQuestions,
        ignoredQuestionCategories:
          this.createdSections[moduleIndex].ignoredQuestionCategories,
      },
      panelClass: 'autoReplace',
    });
    dialogRef
      .afterClosed()
      .subscribe((questionObjTobeReplaced: generatedQuestionObj) => {
        console.log(questionObjTobeReplaced);
        if (questionObjTobeReplaced) {
          const subTopicQuestionDetailObj: subTopicQuestionDetailNew = {
            questionDetails: questionObjTobeReplaced,
            subTopicId: currentQuestion.subTopicId,
            questionType: currentQuestion.questionType,
            difficultLevel: currentQuestion.difficultLevel,
            subTopicName: currentQuestion.subTopicName,
          };
          this.createdSections[moduleIndex].generatedQuestions.splice(
            questionIndex,
            1,
            subTopicQuestionDetailObj
          );
          this.createdSections[moduleIndex].subTopicQuestionDetails.forEach(
            (subTopicQuestionDetail, subTopiQuestionDetailIndex) => {
              if (
                subTopicQuestionDetail.subTopicId === currentQuestion.subTopicId
              ) {
                subTopicQuestionDetail.questionSpecifications.forEach(
                  (quesSpec, quesSpecIndex) => {
                    quesSpec.questions?.forEach((ques, quesIndex) => {
                      if (
                        ques.questionDetails.question.questionId ===
                        currentQuestion.questionDetails.question.questionId
                      ) {
                        ques.questionDetails = questionObjTobeReplaced;
                      }
                    });
                  }
                );
              }
            }
          );
          this.makeImages();
          this.loadTikz();
          this.notifier.notify(
            'success',
            'Question has been successfully replaced'
          );
        } else {
          this.notifier.notify('error', 'Question has not been replaced');
        }
      });
  }

  trackByIndexFn(index: any, item: any) {
    return index;
  }

  checkForDuplicateQuestions() {
    this.duplicateQuestions = [];
    for (
      let comp1Index = 0;
      comp1Index < this.createdSections.length - 1;
      comp1Index++
    ) {
      let createdSection1 = this.createdSections[comp1Index];
      let comp2Index = comp1Index + 1;
      while (comp2Index < this.createdSections.length) {
        let createdSection2 = this.createdSections[comp2Index];
        if (createdSection1.sectionType === createdSection2.sectionType) {
          let foundScoringSection = this.scoringSectionsList.find(
            (scoringSection) =>
              scoringSection.scoring_section_type_id ===
              createdSection2.sectionType
          );
          createdSection1.generatedQuestions.forEach(
            (genQuesObj1, genQuesObj1Index) => {
              createdSection2.generatedQuestions.forEach(
                (genQuesObj2, genQuesObj2Index) => {
                  if (
                    genQuesObj1.questionDetails.question.questionId ===
                    genQuesObj2.questionDetails.question.questionId
                  ) {
                    let questionIdInfoObj: QuestionIdInfo = {
                      scoringSectionName:
                        foundScoringSection?.scoring_section_name!,
                      moduleName: createdSection2.sectionName,
                      questionIdIndex: genQuesObj2Index,
                      questionId:
                        genQuesObj2.questionDetails.question.questionId,
                    };
                    this.duplicateQuestions.push(questionIdInfoObj);
                  }
                }
              );
            }
          );
        }
        comp2Index++;
      }
      // createdSection1.generatedQuestions.forEach;
    }
    if (this.duplicateQuestions.length > 0) {
      this.showDuplicatesPopup = true;
      this.isDuplicateSaveAllowed = false;
    } else {
      this.showDuplicatesPopup = false;
    }
    console.log(this.duplicateQuestions);
  }

  finalSave() {
    this.checkValidity();
    this.isSaveClicked = true;
    if (this.isSaveValid && this.isValidQuesstionaire) {
      if (!this.isDuplicateSaveAllowed) {
        this.checkForDuplicateQuestions();
      }
      if (this.isDuplicateSaveAllowed || this.duplicateQuestions.length <= 0) {
        this.isDataLoading = true;
        this.createdSections.forEach((createdSection, createdSectionIndex) => {
          let moduleSaveObj: saveTestModule = {
            breakAfterModule: false,
            breakDuration: 0,
            canPauseModule: false,
            id: '',
            moduleDuration: 0,
            moduleName: '',
            moduleOrder: 0,
            questionsInfo: [],
            scoringSectionId: 0,
            subTopicQuestionDetails: [],
            totalFreeText: 0,
            totalMCQ: 0,
            canRepeatQuestions: false,
            ignoredQuestionCategories: [],
            onlyExerciseQuestions: false,
            onlyQuizQuestions: false,
          };
          moduleSaveObj.breakAfterModule = createdSection.breakAfterModule;
          if (moduleSaveObj.breakAfterModule) {
            let breakDurationStr = (
              createdSection.breakDuration as string
            ).split(' ')[0];
            let parsedBreakDuration = parseInt(breakDurationStr);
            moduleSaveObj.breakDuration = parsedBreakDuration;
          } else {
            moduleSaveObj.breakDuration = 0;
          }
          moduleSaveObj.canPauseModule = createdSection.canBePaused;
          if (!this.isInGet) {
            moduleSaveObj.id = '';
          } else if (this.isInGet) {
            moduleSaveObj.id = createdSection.id;
          }
          let totalDurationStr = (createdSection.totalDuration as string).split(
            ' '
          )[0];
          let parsedTotalDuration = parseInt(totalDurationStr);
          moduleSaveObj.moduleDuration = parsedTotalDuration * 60;
          moduleSaveObj.moduleName = createdSection.sectionName;
          moduleSaveObj.moduleOrder = createdSectionIndex;
          console.log(createdSection.generatedQuestions);
          createdSection.generatedQuestions.forEach(
            (generatedQuestion, generatedQuestionIndex) => {
              // TODO: Confirm whether each questionId is different irrespective of subTopicId
              // generatedQuestion.questionTestTypes[0].subTopicId
              const questionInfoObj: questionInfo = {
                subTopicId: generatedQuestion.subTopicId,
                difficultyLevel: generatedQuestion.difficultLevel,
                questionId:
                  generatedQuestion.questionDetails.question.questionId,
                questionOrder: generatedQuestionIndex + 1,
              };
              console.log(generatedQuestion);
              if (generatedQuestion.questionDetails.moduleQuestionId) {
                questionInfoObj.moduleQuestionId =
                  generatedQuestion.questionDetails.moduleQuestionId;
              }
              moduleSaveObj.questionsInfo.push(questionInfoObj);
            }
          );
          moduleSaveObj.scoringSectionId = createdSection.sectionType as number;
          // let moduleSubtopicDetail = this.generateQuestionsFinalData.find(
          //   (questionFinalData) =>
          //     questionFinalData.moduleId === createdSection.moduleId
          // );
          createdSection.subTopicQuestionDetails.forEach(
            (subTopicDetailObj, subTopicDetailObjIndex) => {
              subTopicDetailObj.questionSpecifications.forEach(
                (questionSpec, questionSpecIndex) => {
                  delete questionSpec.questions;
                }
              );
            }
          );
          let moduleQuestionData = this.generatedDisplayModules.find(
            (displayModule) =>
              displayModule.moduleId === createdSection.moduleId
          );
          moduleSaveObj.canRepeatQuestions =
            createdSection.canRepeatQuestions as boolean;
          moduleSaveObj.ignoredQuestionCategories =
            createdSection.ignoredQuestionCategories;
          moduleSaveObj.onlyExerciseQuestions =
            createdSection.onlyExerciseQuestions;
          moduleSaveObj.onlyQuizQuestions = createdSection.onlyQuizQuestions;
          moduleSaveObj.subTopicQuestionDetails =
            createdSection.subTopicQuestionDetails;
          // let moduleWiseData = this.generatedModuleWiseQuestionTypeData.find(
          //   (genModuleWiseData) =>
          //     genModuleWiseData.moduleId === createdSection.moduleId
          // );
          let moduleWiseData = createdSection.questionTypeCount;
          moduleSaveObj.totalFreeText = moduleWiseData?.totalFreetext as number;
          moduleSaveObj.totalMCQ = moduleWiseData?.totalMcqs as number;
          // console.log(moduleSubtopicDetail);
          // moduleSubtopicDetail?.subTopicQuestionDetails = this.generateQuestionsFinalData.find(())
          // moduleSaveObj.subTopicQuestionDetails
          console.log(moduleSaveObj);
          this.saveTestObj.testModuleDetails.push(moduleSaveObj);
        });
        this.saveTestObj.testName = this.testName;
        this.saveTestObj.testCode = this.testId.value;
        this.saveTestObj.testNotes = '';
        this.saveTestObj.testTypeId = this.selectedTestType.value;
        console.log(this.saveTestObj);
        if (!this.isInGet) {
          this.globalApiService.saveTestCreation(this.saveTestObj).subscribe({
            next: (res) => {
              console.log(res);
              this.isDataLoading = false;
              this.notifier.notify(
                'success',
                `Test ${this.saveTestObj.testCode} has been saved successfully`
              );
              this.resetEverything();
            },
            error: (err) => {
              this.isDataLoading = false;
              console.log(err);
              this.notifier.notify('error', 'unable to save the test');
              (this.saveTestObj.testName = ''),
                (this.saveTestObj.testTypeId = 0),
                (this.saveTestObj.testModuleDetails = []);
            },
          });
        } else {
          this.globalApiService
            .updateExistingTest(this.recievedTestId, this.saveTestObj)
            .subscribe({
              next: (res) => {
                // console.log(res);
                this.isDataLoading = false;
                this.notifier.notify(
                  'success',
                  `Test ${this.saveTestObj.testCode} has been updated successfully`
                );
                this.resetEverything();
                this.getTestIdParam();
              },
              error: (err) => {
                this.isDataLoading = false;
                console.log(err);
                this.notifier.notify('error', 'unable to update the test');
                // (this.saveTestObj.testName = ''),
                //   (this.saveTestObj.testTypeId = 0),
                //   (this.saveTestObj.testModuleDetails = []);
              },
            });
        }
      }
      // this.isDataLoading = false;
    } else {
      this.isDataLoading = false;
      let errorString: string = this.testId.invalid
        ? 'Please enter the Test ID'
        : this.createdSections.length <= 0
        ? 'Please Add Test Sections'
        : 'Please check modules are invalid';
      this.notifier.notify('error', errorString);
      this.createdSections.forEach((createdSection, createdSectionIndex) => {
        if (createdSection.questionTypeCount.totalQuestions <= 0) {
          this.notifier.notify(
            'error',
            `${createdSection.sectionName} : Please check, No questions have been added`
          );
        } else if (
          createdSection.questionTypeCount.totalQuestions !==
          createdSection.questionTypeCount.generatedQuestions
        ) {
          this.notifier.notify(
            'error',
            `${createdSection.sectionName} : Please check, Number of questions requested do not match with generated `
          );
        }
      });
      if (this.isLeftSectionHidden) {
        this.isLeftSectionHidden = false;
      }
    }
  }

  testSaveApiCall() {
    let lol: any = {
      testModuleDetails: [
        {
          breakAfterModule: true,
          breakDuration: 10,
          canPauseModule: true,
          moduleDuration: '11',
          moduleName: 'Module 123',
          scoringSectionId: 1,
          moduleOrder: 1,
          questionsInfo: [
            {
              subTopicId: 10,
              difficultyLevel: 2,
              questionId: 510,
            },
            {
              subTopicId: 10,
              difficultyLevel: 2,
              questionId: 511,
            },
          ],
          subTopicQuestionDetails: [
            {
              questionSpecifications: [
                {
                  difficultLevel: 1,
                  noOfQuestions: 2,
                  questionType: 1,
                },
                {
                  difficultLevel: 2,
                  noOfQuestions: 2,
                  questionType: 1,
                },
              ],
              subTopicId: 10,
            },
          ],
          totalFreeText: 0,
          totalMCQ: 4,
        },
        {
          breakAfterModule: false,
          breakDuration: 0,
          canPauseModule: true,
          moduleDuration: '21',
          moduleName: 'Math 2',
          scoringSectionId: 2,
          moduleOrder: 2,
          questionsInfo: [
            {
              subTopicId: 11,
              difficultyLevel: 2,
              questionId: 510,
            },
            {
              subTopicId: 11,
              difficultyLevel: 2,
              questionId: 511,
            },
          ],
          subTopicQuestionDetails: [
            {
              questionSpecifications: [
                {
                  difficultLevel: 1,
                  noOfQuestions: 2,
                  questionType: 1,
                },
                {
                  difficultLevel: 2,
                  noOfQuestions: 2,
                  questionType: 1,
                },
              ],
              subTopicId: 11,
            },
          ],
          totalFreeText: 0,
          totalMCQ: 0,
        },
      ],
      testName: 'New SAT Test',
      testCode: 'NSAT101',
      testNotes: 'This is Sample test creation',
      testTypeId: 1,
    };
    this.globalApiService.saveTestCreation(lol).subscribe(
      (res) => {
        // console.log(res);
        this.notifier.notify(
          'success',
          `${this.saveTestObj.testName} has been saved successfully`
        );
      },
      (err) => {
        console.log(err);
        this.notifier.notify('error', 'unable to save the test');
        (this.saveTestObj.testName = ''),
          (this.saveTestObj.testTypeId = 0),
          (this.saveTestObj.testModuleDetails = []);
      }
    );
  }

  autoReplaceCaller(moduleIndex: number, questionIndex: number) {
    this.makePresentQuestionIds(moduleIndex);
    let autoReplaceQuestionData =
      this.createdSections[moduleIndex].generatedQuestions[questionIndex];
    console.log(autoReplaceQuestionData, this.createdSections[moduleIndex]);
    let data: autoReplaceStruct = {
      difficultLevel: autoReplaceQuestionData.difficultLevel,
      existingQuestionIds: this.presentQuestionIds,
      questionType: autoReplaceQuestionData.questionType,
      subTopicId: autoReplaceQuestionData.subTopicId,
      canRepeatQuestions: this.createdSections[moduleIndex].canRepeatQuestions,
      ignoredQuestionCategories:
        this.createdSections[moduleIndex].ignoredQuestionCategories,
    };
    this.globalApiService.autoReplaceCall(data).subscribe({
      next: (res: generatedQuestionObj) => {
        if (res) {
          const subTopicQuestionDetailObj: subTopicQuestionDetailNew = {
            questionDetails: res,
            subTopicId: autoReplaceQuestionData.subTopicId,
            questionType: autoReplaceQuestionData.questionType,
            difficultLevel: autoReplaceQuestionData.difficultLevel,
            subTopicName: autoReplaceQuestionData.subTopicName,
          };
          this.createdSections[moduleIndex].generatedQuestions[questionIndex] =
            subTopicQuestionDetailObj;
          this.notifier.notify(
            'success',
            'Question has been Auto replaced successfully'
          );
          // console.log(
          //   this.generatedDisplayModules[moduleIndex].generatedQuestions[
          //     questionIndex
          //   ]
          // );
          // TODO: Make a function to load tikz and images by single one.
          this.makeImages();
          this.loadTikz();
        } else {
          this.notifier.notify(
            'error',
            'No Questions are available to replace'
          );
        }
      },
      error: (err) => {
        this.notifier.notify(
          'error',
          'Error Fetching the Auto replace Question'
        );
        console.log(err);
      },
    });
  }

  resetEverything() {
    this.createdSections = [];
    this.generatedDisplayModules = [];
    this.generateQuestionsFinalData = [];
    this.moduleValidityList = [];
    this.generatedModuleWiseQuestionTypeData = [];
    this.generatedModules = [];
    this.images = null;
    this.testId.reset();
    this.testName = '';
    this.subTopicsByScoringAndTestIdList = [];
    this.scoringSectionWithSubTopics = {};
    this.saveTestObj = {
      testModuleDetails: [],
      testCode: '',
      testName: '',
      testNotes: '',
      testTypeId: 0,
    };
    this.presentQuestionIds = [];
    this.duplicateQuestions = [];
    this.getCourses();
    this.getTestTypes();
    this.scoringSectionsList = [];
    this.selectedTestType.reset();
    this.isSaveValid = false;
    this.isValidQuesstionaire = false;
    this.isDuplicateSaveAllowed = false;
    this.showDuplicatesPopup = false;
    this.isDataLoading = false;
  }

  deleteSection(index: number) {
    this.createdSections.splice(index, 1);
    this.createdSections.forEach((section) => {
      if (section.moduleOrder > index) {
        section.moduleOrder--;
      }
    });
    console.log(this.createdSections);
  }

  drop(event: CdkDragDrop<any[]>, moduleIndex: number, dropType: string) {
    if (dropType === 'question') {
      moveItemInArray(
        this.createdSections[moduleIndex].generatedQuestions,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      moveItemInArray(
        this.createdSections,
        event.previousIndex,
        event.currentIndex
      );
      if (this.currentSection === event.previousIndex) {
        this.currentSection = event.currentIndex;
      }
    }
  }

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }
}
